/* ============================================================
   bundle-discount.js
   Upload to: Shopify Admin → Online Store → Themes → Assets
   ============================================================ */

(function () {
  'use strict';

  // ── Read config injected by Liquid ──────────────────────────
  const CONFIG = window.BundleConfig || {
    discountPct:  15,
    bundleSize:   3,
    discountCode: 'BUNDLE15',
  };

  // ── DOM refs ─────────────────────────────────────────────────
  const widget       = document.getElementById('bundle-discount-widget');
  if (!widget) return; // snippet not on page

  const cards        = Array.from(widget.querySelectorAll('.bundle-product-card'));
  const countEl      = document.getElementById('bundle-selected-count');
  const progressFill = document.getElementById('bundle-progress-fill');
  const ctaBar       = document.getElementById('bundle-cta-bar');
  const ctaItems     = document.getElementById('bundle-cta-items');
  const ctaOriginal  = document.getElementById('bundle-cta-original');
  const ctaDiscounted= document.getElementById('bundle-cta-discounted');
  const addBtn       = document.getElementById('bundle-add-btn');
  const loadingEl    = document.getElementById('bundle-loading');
  const progressTrack= widget.querySelector('.bundle-widget__progress-track');

  // ── State ────────────────────────────────────────────────────
  let selected = new Set(); // variant IDs

  // ── Utilities ────────────────────────────────────────────────
  const formatMoney = (cents) => {
    // Uses Shopify's global if available, otherwise plain formatting
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  };

  const getCardData = (card) => {
    const select = card.querySelector('.bundle-product-card__variant-select');
    const variantId = select
      ? select.value
      : card.dataset.variantId;
    const price = select
      ? parseInt(select.selectedOptions[0].dataset.price, 10)
      : parseInt(card.dataset.price, 10);
    return {
      productId: card.dataset.productId,
      variantId,
      price,
      title: card.dataset.title,
    };
  };

  // ── Variant change (called from onchange on the select) ──────
  window.bundleUpdateVariant = function (selectEl) {
    const card = selectEl.closest('.bundle-product-card');
    const data = getCardData(card);
    // If this card is already selected, swap the variant ID in the set
    if (card.classList.contains('is-selected')) {
      // Remove old variant IDs for this card's product
      selected.forEach((id) => {
        // We identify "belongs to this card" by checking all options
        const allOptionValues = Array.from(selectEl.options).map(o => o.value);
        if (allOptionValues.includes(id)) selected.delete(id);
      });
      selected.add(data.variantId);
    }
    // Update price display immediately
    const priceEl = card.querySelector('.bundle-product-card__price');
    const origEl  = card.querySelector('.bundle-product-card__original-price');
    const complete = selected.size === CONFIG.bundleSize;
    if (complete && card.classList.contains('is-selected')) {
      priceEl.textContent = formatMoney(Math.round(data.price * (1 - CONFIG.discountPct / 100)));
      origEl.textContent  = formatMoney(data.price);
    } else {
      priceEl.textContent = formatMoney(data.price);
    }
    update();
  };

  // ── Card interaction ─────────────────────────────────────────
  cards.forEach((card) => {
    card.addEventListener('click',    () => toggleCard(card));
    card.addEventListener('keydown',  (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleCard(card);
      }
    });
  });

  function toggleCard(card) {
    const { variantId } = getCardData(card);
    const bundleComplete = selected.size >= CONFIG.bundleSize;

    if (selected.has(variantId)) {
      selected.delete(variantId);
    } else {
      if (bundleComplete) return; // already full
      selected.add(variantId);
    }

    update();
  }

  // ── Core update ──────────────────────────────────────────────
  function update() {
    const count    = selected.size;
    const complete = count === CONFIG.bundleSize;

    // Progress bar
    countEl.textContent = count;
    progressFill.style.width = `${(count / CONFIG.bundleSize) * 100}%`;
    if (progressTrack) {
      progressTrack.setAttribute('aria-valuenow', count);
    }

    // Per-card state
    let subtotalCents = 0;
    const selectedTitles = [];

    cards.forEach((card) => {
      const data = getCardData(card);
      const isSel = selected.has(data.variantId);

      card.classList.toggle('is-selected', isSel);
      card.setAttribute('aria-pressed', isSel ? 'true' : 'false');

      // Dim cards that aren't selected once bundle is full
      card.classList.toggle(
        'is-dimmed',
        complete && !isSel
      );

      // Price display
      const priceEl    = card.querySelector('.bundle-product-card__price');
      const originalEl = card.querySelector('.bundle-product-card__original-price');

      if (complete && isSel) {
        card.classList.add('bundle-live');
        const discountedCents = Math.round(data.price * (1 - CONFIG.discountPct / 100));
        priceEl.textContent = formatMoney(discountedCents);
        originalEl.textContent = formatMoney(data.price);
        subtotalCents += data.price;
        selectedTitles.push(data.title);
      } else {
        card.classList.remove('bundle-live');
        priceEl.textContent = formatMoney(data.price);
        originalEl.textContent = formatMoney(data.price);
        if (isSel) {
          subtotalCents += data.price;
          selectedTitles.push(data.title);
        }
      }
    });

    // CTA bar
    if (complete) {
      const discountCents = Math.round(subtotalCents * (CONFIG.discountPct / 100));
      const totalCents    = subtotalCents - discountCents;

      ctaItems.textContent    = selectedTitles.join(' · ');
      ctaOriginal.textContent = formatMoney(subtotalCents);
      ctaDiscounted.textContent = formatMoney(totalCents);

      ctaBar.classList.add('is-visible');
      ctaBar.setAttribute('aria-hidden', 'false');
    } else {
      ctaBar.classList.remove('is-visible');
      ctaBar.setAttribute('aria-hidden', 'true');
    }
  }

  // ── Add to cart + apply discount ─────────────────────────────
  addBtn.addEventListener('click', addBundleToCart);

  async function addBundleToCart() {
    if (selected.size < CONFIG.bundleSize) return;

    loadingEl.classList.add('is-active');
    addBtn.disabled = true;

    try {
      // 1. Clear existing cart (optional — remove if you want to keep existing items)
      // await fetch('/cart/clear.js', { method: 'POST' });

      // 2. Add all selected variants to cart
      const items = cards
        .filter((c) => selected.has(getCardData(c).variantId))
        .map((c) => ({
          id:       parseInt(getCardData(c).variantId, 10),
          quantity: 1,
        }));

      const addResponse = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });

      if (!addResponse.ok) {
        const err = await addResponse.json();
        throw new Error(err.description || 'Could not add items to cart.');
      }

      // 3. Apply discount code
      try {
        await fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ discount: CONFIG.discountCode }),
        });
      } catch (_) { /* silent */ }

      // 4. Refresh drawer contents then open it
      // Fetch the latest cart-drawer section HTML so the drawer shows the
      // newly added items instead of stale/empty content.
      try {
        const sectionRes = await fetch('/?section_id=cart-drawer');
        const sectionHtml = await sectionRes.text();
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

        // Update the inner drawer DOM
        const newCartDrawer = doc.getElementById('CartDrawer');
        const existingCartDrawer = document.getElementById('CartDrawer');
        if (newCartDrawer && existingCartDrawer) {
          existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }

        // Also refresh the cart bubble count in the header
        const bubbleRes = await fetch('/?section_id=cart-icon-bubble');
        const bubbleHtml = await bubbleRes.text();
        const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        const newBubble = bubbleDoc.getElementById('cart-icon-bubble');
        const existingBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && existingBubble) {
          existingBubble.innerHTML = newBubble.innerHTML;
        }
      } catch (_) { /* silent — drawer will still open even if refresh fails */ }

      loadingEl.classList.remove('is-active');
      addBtn.disabled = false;

      // Open the cart drawer
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl) {
        cartDrawerEl.classList.remove('is-empty');
        if (typeof cartDrawerEl.open === 'function') {
          cartDrawerEl.open();
        } else {
          cartDrawerEl.classList.add('animate', 'active');
        }
      } else if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
        window.cartDrawer.classList.remove('is-empty');
        window.cartDrawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }

    } catch (error) {
      loadingEl.classList.remove('is-active');
      addBtn.disabled = false;
      alert(`Oops! ${error.message || 'Something went wrong. Please try again.'}`);
      console.error('[BundleDiscount]', error);
    }
  }

  // ── Init ─────────────────────────────────────────────────────
  update();

})();
